var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileRecruitTwoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 305.375,
    height: 17.85,
    viewBox: "0 0 305.375 17.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile_recruit_two_icon_v2",
    transform: "translate(6926 -170.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139013",
    "data-name": "\\uD328\\uC2A4 139013",
    d: "M7.625-3.925l3.3-3.05c2.5-2.3,2.975-3.85,2.975-5.55,0-3.25-2.775-5.325-6.8-5.325-3.45,0-5.925,1.45-7.25,3.65l3.675,2.05a3.577,3.577,0,0,1,3.125-1.7c1.5,0,2.25.675,2.25,1.8,0,.725-.2,1.525-1.6,2.825L.75-3.1V0H14.375V-3.925Z",
    transform: "translate(-6635 187.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139014",
    "data-name": "\\uD328\\uC2A4 139014",
    d: "M280.984.5H0v-1H280.984Z",
    transform: "translate(-6922.061 181.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139015",
    "data-name": "\\uD328\\uC2A4 139015",
    d: "M3.939,0A3.939,3.939,0,1,1,0,3.939,3.939,3.939,0,0,1,3.939,0Z",
    transform: "translate(-6926 177.951)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRecruitTwoIcon);
export default __webpack_public_path__ + "static/media/mobile_recruit_two_icon.888f56b5c86f3d23b2f827ac09673da1.svg";
export { ForwardRef as ReactComponent };